<template>
  <div class="finPagContainer">
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div class="search-container">
      <v-text-field v-model="search" append-icon="mdi-magnify" label="Pesquisar" outlined dense clearable hide-details
        class="search-bar">
      </v-text-field>
    </div>

    <Listar v-if="showFuncoes" @fecharCardListar="closeListar" :menu="menuSelected" />

    <v-data-table :headers="headers" :items="produtos" :search="search" class="configuracoes-table">
      <template v-slot:item.index="{ item }">
        <span>{{ produtos.indexOf(item) + 1 }}</span>
      </template>

      <!-- Ações por item -->
      <template v-slot:item.action="{ item }">
        <v-menu bottom origin="center center" transition="scale-transition">
          <template v-slot:activator="{ on }">
            <v-btn fab dark color="#006699" class="action-btn" v-on="on">
              <v-icon>menu</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="exibirItens(item)">
              <v-icon color="green" small class="mr-2">more</v-icon> Ver Itens
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>

  </div>
</template>

<script>
import Swal from 'sweetalert2';
import axios from '../../plugins/axios';
import Listar from '../../components/ItensMenu/Listar.vue';

export default {
  data() {
    return {
      isLoading: false,
      search: "",
      headers: [
        { text: '#', value: 'index', },
        { text: 'Menu', value: 'descricaoMenu' },
        { text: 'Total de itens', value: 'itens' },
        { text: 'Autor', value: 'createdBy' },
        { text: 'Data', value: 'createdOn' },
        { text: 'Ações', value: 'action' },
      ],
      produtos: [],
      showFuncoes: false,
      menuSelected: null
    };
  },

  components: {
    Listar
  },

  created() {
    this.initializeItems();
  },

  methods: {
    async initializeItems() {
      this.isLoading = true;
      try {
        const response = await axios.get('/getItensMenu');
        this.produtos = response.data;
      } catch (error) {
        Swal.fire('Informação', 'Erro ao carregar os menus', 'error');
      } finally {
        this.isLoading = false;
      }
    },

    exibirItens(menu) {
      this.menuSelected = menu;
      this.showFuncoes = true;
    },

    closeListar(bool) {
      this.showFuncoes = false;
      this.menuSelected = null;
      if (bool) {
        this.initializeItems();
      }
    }
  }
};

</script>

<style></style>